import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { graphContainer } from './graphContainers';
import { ColorPalette } from '../DashboardColorPalettes';
import GenericCategoryGraph, { chartTypeEnum } from '../../../components/Graphs/GenericCategoryGraph';

const dayRanges = [
  {label: '0 days', value: 1},
  {label: '1 day', value: 2},
  {label: '2 days', value: 3},
  {label: '3 days', value: 4},
  {label: '4 days', value: 5},
  {label: '5 days', value: 6},
  {label: '6 - 10 days', value: 11},
  {label: '10+ days', value: 10000},
];

export const PatientsWithNoReadingsForXDaysMetadata = {
    id: 'patients_with_no_readings',
    name: 'Patients with no readings for last X days',
    permission: '',
    defProps: { i: 'patients_with_no_readings', w: 4, h: 4, minW: 2, minH: 4 },
    configuration: {
      chartType: {
        type: 'select',
        name: 'chartType',
        label: 'Chart Type',
        defaultValue: chartTypeEnum.line,
        options: [
          { label: 'Area chart', value: chartTypeEnum.area },
          { label: 'Line chart', value: chartTypeEnum.line },
          { label: 'Pie chart', value: chartTypeEnum.pie },
          { label: 'Bar chart', value: chartTypeEnum.bar },
          { label: 'Horizontal Bar chart', value: chartTypeEnum.horizontalBar },
          { label: 'Grid', value: "grid" },
        ],
        canBeSetByDashboard: false,
      },
    }
};

function PatientsWithNoReadingsForXDays(props) {
  const { data, colorPalette, graphType } = props;

  const dataSeries = [{
    name: 'Number of patients',
    // color: colorPalette?.interpolate(0.73),
    selector: item => item.count,
  }];

   const graphData = !data?.no_vitals_by_days ? [] : Object.keys(data.no_vitals_by_days).map(i => i === '-1' ? 666 : parseInt(i, 10)).sort((a, b) => a - b).map(i => ({
    count: data?.no_vitals_by_days?.[i === 666 ? '-1' : i] || 0,
    days: i,
  }));

  const condensedData = dayRanges.map((d, i) => {
    const entries = graphData.filter(v => v.days < d.value && (i > 1 ? d.value >= dayRanges[i - 1].value : true));
    return {
      count: entries.reduce((sum, v) => sum + v.count, 0),
      days: d.label,
    };
  });

  const grid = (
    <div className="box2colsWithVl vncols" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))' }}>
      {condensedData &&
        condensedData.map(v => (
          <div className="box2colsWithVl-box" key={v.days}>
            <div className="box2colsWithVl-valueBox black">
              {v.count}
            </div>
            <div className="box2colsWithVl-labelBox">
              {v.days}
            </div>
          </div>
        ))}
    </div>
  );

  const graph = (
    <GenericCategoryGraph
      graphData={graphType === chartTypeEnum.line || graphType === chartTypeEnum.area ? graphData.slice(0, graphData.length - 1) : condensedData}
      hasBorder
      forceCondensed
      xAxisTopPosition={false}
      yAxisWidth={graphType === chartTypeEnum.horizontalBar ? 100 : 40}
      xAxisType={graphType === chartTypeEnum.line || graphType === chartTypeEnum.area ? 'number' : 'category'}
      tooltipTitle="Number of patients with no readings for the last X days"
      dataSeries={dataSeries}
      categorySelector={item => item.days}
      hasReferenceAreas
      graphType={graphType}
      colorPalette={colorPalette}
    />
  );
  return graphContainer(graphType === "grid" ? grid : graph, "Number of patients with no readings for the last X days");
}

PatientsWithNoReadingsForXDays.propTypes = {
  getPatientsStatistics: PropTypes.func,
  onClick: PropTypes.func,
  colorPalette: PropTypes.any,
  refreshTimestamp: PropTypes.any,
  graphType: PropTypes.string,
  orgId: PropTypes.string,
  dragging: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    colorPalette:
      ColorPalette[state.dashboardState.configuration?.allDashboards?.colorPalette] || Object.values(ColorPalette)[0],
  };
};

export default connect(mapStateToProps, null)(PatientsWithNoReadingsForXDays);
